import { render, staticRenderFns } from "./AudioPanel.vue?vue&type=template&id=79ebe8d6&scoped=true&"
import script from "./AudioPanel.vue?vue&type=script&lang=js&"
export * from "./AudioPanel.vue?vue&type=script&lang=js&"
import style0 from "./AudioPanel.vue?vue&type=style&index=0&id=79ebe8d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ebe8d6",
  null
  
)

export default component.exports